import LocalLanding from "./LocalLanding";
export default function LandingCascais() {
    return (
        <LocalLanding
            city="Cascais"
            canonicalSlug="remodelacoes-cascais"
            hero="https://images.unsplash.com/photo-1761134427070-9e1ba8270a69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
